/**
 * Shared Demo Organization Configuration
 *
 * REQUIREMENTS SUMMARY:
 * - Defines the well-known ID and metadata for the single shared demo org.
 * - All demo enter/exit flows reference these constants.
 * - The demo org is seeded once per environment (local + production) and persists forever.
 * - Multiple users share the same read-only demo org simultaneously.
 */

/** Fixed UUID for the shared "CheerVue Demo Gym" demo organization. */
export const SHARED_DEMO_ORG_ID = 'b0000000-de10-4000-a000-c0ee00000000';

/** Display name for the demo organization (shown in the org switcher header). */
export const SHARED_DEMO_ORG_NAME = 'CheerVue Demo Gym';

/** localStorage key for the real gym the user was on before entering demo. */
export const DEMO_REAL_ORG_STORAGE_KEY = 'demoRealOrgId';

/** Email domain for fake demo auth_users (coaches, parents). Never receives real mail. */
export const DEMO_EMAIL_DOMAIN = '@cheervue.demo';

/**
 * app_metadata the demo seed puts on every account it creates. Only the service
 * role can write app_metadata, so a user cannot add it to their own account.
 * RLS reads it (`demo_viewer_person_ids()`) to show seeded demo people to demo
 * viewers. Keep the key in step with that function.
 */
export const DEMO_SEED_APP_METADATA = { cheervue_demo_seed: true } as const;
